import Vue from 'vue'
import store from '@/store'
import router from '@/router'
Vue.use({
  install() {
    Vue.prototype.$moduleState = {
      reset(moduleName = '') {
        console.debugVerboseScope(5, '$moduleState', 'reset', {
          moduleName,
        })
        let routeTo = {
          blackspotModule: 'blackspotList',
          containersModule: 'containers_module_selection',
        }
        switch (moduleName) {
          //Location is special (dynamic layout)
          case 'location_module':
            store.dispatch('search_module/resetStore')
            store.dispatch('location_module/resetStore')
            store.dispatch('app/changeLayout', {
              origin: 'reset-modulestate::reset',
              sub_menu: false,
              right_menu: false,
              right_menu_bottom: false,
              menu_collapsed: false,
            })
            break
          //Switching to a blank page for a second and returning to the module
          case 'containers_management': //This also uses dynamic layout ?
          case 'diagnostics_module':
          case 'zones_module':
          case 'alerts_module':
          case 'sensors_module':
          case 'ecoconduite_module':
          case 'events_module':
          case 'messages_module':
            reloadModule(moduleName)
            break
          default:
            if (moduleName.startsWith('containers_module')) {
              return reloadModule(routeTo.containersModule)
            }
            if (moduleName.startsWith('blackspot')) {
              return reloadModule(routeTo.blackspotModule)
            }
            break
        }

        function reloadModule(routeName) {
          console.log
          store.dispatch('search_module/resetStore')
          router.push({
            name: 'reload_screen',
            params: {
              redirectTo: routeName,
            },
          })
        }
      },
    }
  },
})
